import anime from 'animejs'

//время точно вычислено и смотрится опримально. Можешь не пробовать менять.
let duration = 365;
let easing = 'linear';

export default {
  name: 'pointer-to-project-description',
  data(){
    return {
      timeline: null,   //:anime timeline
      interval: null,   //setInterval Timer
      isHovered: false,
      isMicrosoftEdge: window.navigator.userAgent.indexOf("Edge") > -1
    }
  },
  methods: {
    createAnimeTimeline(){
      let timeline = anime.timeline({
        loop: true,
        autoplay: false,
        easing,
        update: (anim) => {
          if (anim.progress ==  100
            && this.isHovered == false
          ) {
            this.timeline.pause()
          }
        }
      });
      timeline
        .add({
          targets: this.$refs.arrow3,
          scale: 0.85,
          translateY: '8',
          opacity: 0.0,
          duration: duration,
          offset:0
        })
        .add({
          targets: this.$refs.arrow2,
          translateY: '8',
          duration: duration,
          offset: 0
        })
        .add({
          targets: this.$refs.arrow1,
          translateY: '8',
          duration: duration,
          offset: 0
        })
        .add({
          targets: this.$refs.arrow0,
          opacity: 1,
          translateY: '8',
          scale: 1,
          duration: duration,
          offset:0
        })
      timeline.finished.then(()=>{
        // console.log('finished')
      });
      this.timeline = timeline;
    },
    scroll(e){
      document.querySelector(this.$refs.anchor.hash).scrollIntoView({ behavior: 'smooth' });
      this.stopAnimation()
    },
    startAnimation(){
      // console.log('startAnimation')
      clearInterval(this.timer)
      this.isHovered = true;
      if (!this.isMicrosoftEdge){
        this.timeline.play()
      }

    },
    stopAnimation(){
      // console.log('stopAnimation')
      this.isHovered = false;
      this.startInterval();
    },
    startInterval(){
      this.timer = setInterval(()=>{
        if (this.isHovered == false){
          // console.log('here')
          if (!this.isMicrosoftEdge) {
            this.timeline.restart();
          }

        }
      },3000)
    }
  },
  mounted() {
    this.createAnimeTimeline();
    this.startInterval();
  }
}



// WEBPACK FOOTER //
// ./src/includes/PointerToProjectDescription.js